const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');
const GraphQLMutation = require('app/graphql/Mutation');
const GraphQLMultiMutation = require('app/graphql/MultiMutation');

const ListTable = require('app/ui/list/Table');
const ConfirmModal = require('app/ui/modal/Confirm');

const ExportPDFModal = require('app/restaurant/bookmark/export/PDFModal');
const ExportExcelModal = require('app/restaurant/bookmark/export/ExcelModal');


class BookmarkTab {
    defaultOptions() {
        return {
            '$container': $('<div/>'),
            'restaurant': {'id':null,'name':null},
            'rangeOptionOffset': '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
            'rangeOptionBookmark': "bookmarked",
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onChangeRange = this.onChangeRange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onClickClear = this.onClickClear.bind(this);
        this.onClickExportPDF = this.onClickExportPDF.bind(this);
        this.onClickExportExcel = this.onClickExportExcel.bind(this);

        this.$container = this.settings.$container;
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.restaurant = this.settings.restaurant;
        this.removals = [];
        this.adds = [];

        this.initialize();
    }

    initialize() {
        var self = this;

        this.$content = $("<div/>")
        .addClass('restaurant-bookmark-list-container')
        .addClass('mt-4');

        this.$btnSubmit = $('<button/>')
        .addClass("btn btn-danger")
        .append(window.translate('app.restaurant.show.tabs.bookmark.submit.label'))
        .on('click',this.onSubmit)

        this.$submitContainer = $('<div/>')
        .addClass('restaurant-bookmark-submit-container')
        .append(
            $('<div/>')
            .addClass('d-flex justify-content-center')
            .append(
                this.$btnSubmit
            )
        )
        .hide();

        this.$container
        .html('')
        .append(this.buildHeader())
        .append(this.$content)
        .append(this.$submitContainer);

        this.loadData();
    }

    buildHeader(){

        this.$btnClear = $('<button/>')
        .attr('type','button')
        .addClass('btn btn-text border-danger text-danger btn-clear')
        .append(
            $('<i/>')
            .addClass('fas fa-trash me-1')
        )
        .append(window.translate('app.restaurant.show.tabs.bookmark.actions.clear.label'))
        .on('click',this.onClickClear)

        this.$btnExportPDF = $('<button/>')
        .attr('type','button')
        .addClass('btn btn-success btn-export-pdf')
        .append(
            $('<i/>')
            .addClass('fas fa-file-pdf me-1')
        )
        .append(window.translate('app.restaurant.show.tabs.bookmark.actions.exportPDF.label'))
        .on('click',this.onClickExportPDF)


        this.$btnExportExcel = $('<button/>')
        .attr('type','button')
        .addClass('btn btn-success btn-export-excel')
        .append(
            $('<i/>')
            .addClass('fas fa-file-excel me-1')
        )
        .append(window.translate('app.restaurant.show.tabs.bookmark.actions.exportExcel.label'))
        .on('click',this.onClickExportExcel)

        this.$header = $('<div/>')
        .addClass('white-box p-4 row');

        this.$rangeSelectorContainer = $('<div/>')
        .addClass('p-2')
        .append(window.App.generateLoader());
        this.$headerActionsContainer = $('<ul/>')
        .addClass('list-inline ')
        .append(
            $('<li/>')
            .addClass('list-inline-item')
            .append(this.$btnClear)
        )
        .append(
            $('<li/>')
            .addClass('list-inline-item')
            .append(this.$btnExportPDF)
        )
        .append(
            $('<li/>')
            .addClass('list-inline-item')
            .append(this.$btnExportExcel)
        );

        this.$header
        .append(
            $('<div/>')
            .addClass('col-6')
            .append(this.$rangeSelectorContainer)
        )
        .append(
            $('<div/>')
            .addClass('col-6 d-flex justify-content-end')
            .append(this.$headerActionsContainer)
        )

        return this.$header;
    }

    loadData(){
        var self = this;

        let queries = [
            this.buildRangeQuery(),
        ];

        let query = new GraphQLMultiQuery({
            //parameters
            'queries': queries,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.buildRangeSelector(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();
    }

    buildRangeQuery(){
        var self = this;

        let parameters = {
            'first': 10000,
            'orderBy': 'name',
            'dir': "ASC",
            'filter': {
                'root': true,
                'restaurant': this.restaurant.id
            }
        };

        let fields = [
            'id',
            'name',
            'childs { id name parent { id } childs { id name parent { id } childs { id name parent { id } } } }'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'supplierProductRanges',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': true,
        });

        return query;
    }

    buildRangeSelector(data){
        var self = this;
        this.ranges = data.supplierProductRanges.edges;


        this.$rangeSelect = $('<select/>')
        .addClass("form-control")
        .on("change",this.onChangeRange);

        this.$rangeSelect
        .append(
            $('<option/>')
            .val('')
            .append(window.translate('app.restaurant.show.tabs.bookmark.range.empty'))
        )
        .append(
            $('<option/>')
            .val(this.settings.rangeOptionBookmark)
            .append(window.translate('app.restaurant.show.tabs.bookmark.range.bookmarks'))
        );

        for(var r in this.ranges){
            let range = this.ranges[r].node;

            let options = this.buildRangeOptions(range);
            for(var o in options){
                let $option = options[o];
                this.$rangeSelect.append($option);
            }
        }


        this.$rangeSelectorContainer
        .html('')
        .append(this.$rangeSelect);

        this.$rangeSelect.trigger('change');
    }

    refresh(){
        this.$rangeSelect.trigger('change');
    }

    buildRangeOptions(range,offset){
        let options = [];

        if(!offset){
            offset = '';
        }

        let $option = $('<option/>')
        .val(range.id)
        .append(offset + range.name);

        if(range.parent == null){
            $option.addClass('fw-bold');
        }

        options.push($option);
        if(range.childs && range.childs.length > 0){
            for(var c in range.childs){
                var child = range.childs[c];
                let childOptions = this.buildRangeOptions(child,offset+this.settings.rangeOptionOffset);
                for(var o in childOptions){
                    let $childOption = childOptions[o];
                    options.push($childOption);
                }
            }
        }

        return options;
    }

    onChangeRange(event){
        this.removals = [];
        this.adds = [];
        this.$submitContainer.hide();
        this.selectedRange = this.$rangeSelect.val();
        this.$content.html('');
        if(!this.selectedRange){
            this.$content
            .append(
                $('<div/>')
                .addClass('p-4 d-flex justify-content-center text-muted')
                .append(window.translate('app.restaurant.show.tabs.bookmark.list.empty'))
            )
        }else{

            this.$content
            .append(
                $('<div/>')
                .addClass('p-4')
                .append(window.App.generateLoader())
            );
            if(this.selectedRange == this.settings.rangeOptionBookmark){
                this.loadBookmarkedProducts();
            }else{
                this.loadProductsForRange(this.selectedRange);
            }
        }
    }

    loadBookmarkedProducts(){
        var self = this;

        let queries = [
            this.buildBookmarkedProductQuery(),
            this.buildRestaurantProductPriceUpdateQuery(),
        ];

        let query = new GraphQLMultiQuery({
            //parameters
            'queries': queries,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.buildBookmarkedList(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();
    }

    buildBookmarkedProductQuery(){
        var self = this;

        let id = this.restaurant.id;
        let parameters = {
            'first': 10000,
            'orderBy': 'reference',
            'dir': "ASC",
            'filter': {
                'restaurant': id
            }
        };

        let fields = [
            'product { id number reference description range { id name } supplier { id name } unit quantity price supplierPrice supplierPriceViewable }'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'restaurantProductBookmarks',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': true,
        });
        return query;
    }


    buildBookmarkedProductIdQuery(){
        var self = this;

        let id = this.restaurant.id;
        let parameters = {
            'first': 10000,
            'filter': {
                'restaurant': id
            }
        };

        let fields = [
            'product { id }'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'restaurantProductBookmarks',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': true,
        });
        return query;
    }

    buildRestaurantProductPriceUpdateQuery(){
        var self = this;

        let id = this.restaurant.id;
        let parameters = {
            'first': 10000,
            'filter': {
                'restaurant': id
            }
        };

        let fields = [
            'product { id }',
            'price'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'restaurantProductPriceUpdates',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': true,
        });
        return query;
    }

    buildProductByRangeQuery(rangeId){
        var self = this;
        let id = this.restaurant.id;

        let parameters = {
            'first': 10000,
            'orderBy': 'reference',
            'dir': 'ASC',
            'filter': {
                'restaurant': id,
                'rootRange': parseInt(rangeId),
                'orphan': false,
                'status': 1
            }
        };

        let fields = [
            'id',
            'number',
            'reference',
            'description',
            'range { id name }',
            'supplier { id name }',
            'unit',
            'quantity',
            'price',
            'supplierPrice',
            'supplierPriceViewable',
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'supplierProducts',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': true,
        });
        return query;
    }

    loadProductsForRange(rangeId){
        var self = this;

        let queries = [
            this.buildBookmarkedProductIdQuery(),
            this.buildProductByRangeQuery(rangeId),
            this.buildRestaurantProductPriceUpdateQuery(),
        ];

        let query = new GraphQLMultiQuery({
            //parameters
            'queries': queries,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.buildProductByRangeList(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();
    }

    buildBookmarkedList(data){
        this.restaurantProductBookmarks = data.restaurantProductBookmarks.edges;
        this.restaurantProductPriceUpdates = data.restaurantProductPriceUpdates.edges;

        let products = [];
        for(var i in this.restaurantProductBookmarks){
            let edge = this.restaurantProductBookmarks[i];
            let product = edge.node.product;
            product.bookmarked = true;
            products.push(product);
        }

        return this.buildProductList(products);
    }

    buildProductByRangeList(data){
        this.restaurantProductBookmarks = data.restaurantProductBookmarks.edges;
        this.restaurantProductPriceUpdates = data.restaurantProductPriceUpdates.edges;
        let bookmarkedIds = this.compiledBookmarkedIds(this.restaurantProductBookmarks);
        this.products = data.supplierProducts.edges;

        let products = [];
        for(var i in this.products){
            let edge = this.products[i];
            let product = edge.node;
            if(bookmarkedIds.includes(product.id)){
                product.bookmarked = true;
            }else{
                product.bookmarked = false;
            }
            products.push(product);
        }

        return this.buildProductList(products);
    }

    getRestaurantPrice(product){
        let price = product.price;
        let priceUpdate = this.restaurantProductPriceUpdates.find((item) => item.node.product.id == product.id);
        if(priceUpdate){
            price = priceUpdate.node.price;
        }
        return price;
    }

    compiledBookmarkedIds(bookmarks){
        return bookmarks.map(function(edge){
            return edge.node.product.id;
        })
    }

    buildProductList(products){

        var self = this;

        this.$content.html('');

        this.table = new ListTable({
            '$container': this.$content,
            'tableClass': 'table table-striped restaurant-bookmark-product-list',
            'id': 'list-products',
            'length': products.length,
            'data': products,
            'onDrawLine': function($line,item,index){
                $line
                .attr('data-id',item.id)
                .addClass('bookmark-list-product')
                if(item.bookmarked){
                    $line.addClass('bookmarked')
                }
            },
            'columns': [
                {
                    'name': 'id',
                    'label': "",
                    'class': 'product-selection',
                    'render': function(item,index){
                        let $checkbox = $('<input/>')
                        .attr('type','checkbox')
                        .attr('name',"products[]")
                        .val(item.id)
                        if(item.bookmarked){
                            $checkbox.prop('checked',true);
                        }
                        $checkbox.on("change",function(){
                            let checked = $checkbox.is(':checked');
                            self.onChangeSelection(item.id,checked);
                        });
                        return $checkbox;
                    },
                },
                {
                    'name': 'number',
                    'label': window.translate('app.restaurant.show.tabs.bookmark.product.number.label'),
                    'class': 'product-number',
                    'render': function(item,index){
                        return item.number;
                    },
                },
                {
                    'name': 'reference',
                    'label': window.translate('app.restaurant.show.tabs.bookmark.product.reference.label'),
                    'class': 'product-reference',
                    'render': function(item,index){
                        let $content = $('<div/>')
                        .append(item.reference);
                        if(item.description){
                            $content
                            .append(
                                $('<div/>')
                                .append(
                                    $("<small/>")
                                    .addClass('fst-italic')
                                    .append(item.description)
                                )
                            )
                        }
                        return $content;
                    },
                },
                {
                    'name': 'range',
                    'label': window.translate('app.restaurant.show.tabs.bookmark.product.range.label'),
                    'class': 'product-range',
                    'render': function(item,index){
                        return item.range.name;
                    },
                },
                {
                    'name': 'supplier',
                    'label': window.translate('app.restaurant.show.tabs.bookmark.product.supplier.label'),
                    'class': 'product-supplier',
                    'render': function(item,index){
                        return item.supplier.name;
                    },
                },
                {
                    'name': 'packaging',
                    'label': window.translate('app.restaurant.show.tabs.bookmark.product.packaging.label'),
                    'class': 'product-packaging',
                    'render': function(item,index){
                        return window.formatFloat(item.quantity) + ' ' + item.unit;
                    },
                },
                {
                    'name': 'buyPrice',
                    'label': window.translate('app.restaurant.show.tabs.bookmark.product.buyPrice.label'),
                    'class': 'product-buyprice',
                    'render': function(item,index){
                        return window.formatFloat(item.supplierPrice) + ' &euro;';
                    },
                },
                {
                    'name': 'sellPrice',
                    'label': window.translate('app.restaurant.show.tabs.bookmark.product.sellPrice.label'),
                    'class': 'product-sellprice',
                    'render': function(item,index){
                        let realPrice = self.getRestaurantPrice(item);
                        let $item = $('<div/>')
                        .addClass('product-sellprice-item')
                        .addClass('text-primary')
                        .data('item',item)
                        .attr('data-price',item.price)
                        .attr('data-realprice',realPrice)
                        .append(window.formatFloat(realPrice) + ' &euro;')
                        .on('dblclick',function(event){
                            self.onDblClickSellPrice($item);
                        });

                        return $item;
                    },
                },
                {
                    'name': 'margin',
                    'label': window.translate('app.restaurant.show.tabs.bookmark.product.margin.label'),
                    'class': 'product-margin',
                    'render': function(item,index){
                        let margin = self.computeMargin(item);
                        let $margin = $('<div/>')
                        .addClass('product-margin-item')
                        .attr('data-id',item.id)
                        .append(window.formatFloat(margin,3) + '%');
                        return $margin;
                    },
                }
            ]
        });
    }

    computeMargin(item,forcedPrice){
        let price =  this.getRestaurantPrice(item);
        if(forcedPrice){
            price = forcedPrice;
        }
        return ( ( price - item.supplierPriceViewable ) / item.supplierPriceViewable ) * 100;
    }

    onChangeSelection(item,checked){
        item = parseInt(item);

        if(checked){
            if(this.removals.includes(item)){
                this.removals = this.removals.filter((value) => value != item);
            }else{
                this.adds.push(item);
            }
        }else{
            if(this.adds.includes(item)){
                this.adds = this.adds.filter((value) => value != item);
            }else{
                this.removals.push(item);
            }
        }

        let nbChanges = this.adds.length + this.removals.length;
        if(nbChanges){
            this.$submitContainer.show();
        }else{
            this.$submitContainer.hide();
        }
    }

    onSubmit(event){
        var self = this;

        let mutations = [];
        if(this.adds.length > 0){
            mutations.push(this.buildSubmitBookmarksMutation());
        }
        if(this.removals.length > 0){
            mutations.push(this.buildRemoveBookmarksMutation());
        }

        let multiMutation = new GraphQLMultiMutation({
            'mutationName': 'UpdateBookmarksMutation',

            //parameters
            'mutations': mutations,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.onSubmitSucceed(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        multiMutation.execute();
    }

    onSubmitSucceed(data){
        let success = true;
        let message = '';
        if(this.adds.length){
            let addsResponse = data.SubmitRestaurantProductBookmarks;
            message = addsResponse.message;
            if(addsResponse.success == false){
                success = false;
            }
        }
        if(this.removals.length){
            let removalsResponse = data.DeleteRestaurantProductBookmarks;
            if(!message){
                message = removalsResponse.message;
            }
            if(removalsResponse.success == false){
                success = false;
                message = removalsResponse.message;
            }
        }
        if(success){
            window.notify(message,"success");
            this.clearChanges();
        }else{
            window.notify(message,"danger");
        }
    }

    clearChanges(){
        this.$submitContainer.hide();
        this.removals = [];
        this.adds = [];
    }

    buildSubmitBookmarksMutation(){
        var self = this;

        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'restaurant': {
                'value': this.restaurant.id,
                'type': 'Int!'
            },
            'products': {
                'value': this.adds,
                'type': '[Int]'
            }
        };
        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "SubmitRestaurantProductBookmarks",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}
        });
        return mutation;
    }

    buildRemoveBookmarksMutation(){
        var self = this;

        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'restaurant': {
                'value': this.restaurant.id,
                'type': 'Int!'
            },
            'products': {
                'value': this.removals,
                'type': '[Int]'
            }
        };
        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "DeleteRestaurantProductBookmarks",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}
        });
        return mutation;
    }




    onDblClickSellPrice($item){
        var self = this;
        let realPrice = $item.data('realprice');
        let defaultPrice = $item.data('price');

        let $input = $("<input/>")
        .addClass('product-realprice-input')
        .attr('type',"text")
        .val(realPrice)
        .on("change",function(){
            self.onChangeSellPrice($item);
        });

        $item.html('').append($input);
    }

    onChangeSellPrice($item){
        let item = $item.data('item');
        let $input = $('.product-realprice-input',$item);
        let priceUpdate = $input.val();
        let $margin = $('.product-margin-item[data-id="'+item.id+'"]');
        let margin = this.computeMargin(item,priceUpdate);

        $item
        .html('')
        .append(window.formatFloat(priceUpdate) + ' &euro;')

        $margin
        .html('')
        .append(window.formatFloat(margin,3) + '%');

        let onSuccess = function(){
            $item.data('realprice',priceUpdate);
            $item.attr('data-realprice',priceUpdate);
        };
        
        this.proceedSendPrice(item,priceUpdate,onSuccess);
    }

    proceedSendPrice(item,price,onSuccessCallback){
        var self = this;

        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'restaurant': {
                'value': this.restaurant.id,
                'type': 'Int!'
            },
            'product': {
                'value': item.id,
                'type': 'Int!'
            },
            'price': {
                'value': price,
                'type': 'String!'
            },
        };
        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "SubmitRestaurantProductPriceUpdate",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function(){
            },
            'success': function(data){
                window.notify(data.message,"success");
                onSuccessCallback();
            },
            'error': function(message, xhr){
                window.notify(message,"danger");
            },
            'after': function(){
                // do not refresh now, see issue #16 for more informations
                //self.refresh();
            }
        });
        mutation.execute();
    }

    onClickClear(event){
        var self = this;
        let $content = $('<div/>')
        .append(
            $('<div/>')
            .append(window.translate('app.restaurant.show.tabs.bookmark.actions.clear.confirm'))
        )

        let confirmModal = new ConfirmModal({
            'messageContent': $content,
            'btnConfirmClass': 'btn btn-danger btn-confirm',
            'btnCancelClass': 'btn btn-text text-secondary btn-cancel',
            'onConfirm': function(event,modal){
                self.proceedClear(modal)
            },
            'onCancel': function(event,modal){
            }
        })
        confirmModal.show();
    }

    proceedClear(modal){
        var self = this;

        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'restaurant': {
                'value': this.restaurant.id,
                'type': 'Int!'
            }
        };
        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "ClearRestaurantProductBookmarks",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}
            //callbacks
            'before': function(){
            },
            'success': function(data){
                window.notify(data.message,"success");
                self.refresh();
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
                modal.dispose();
            }
        });
        mutation.execute();
    }

    onClickExportPDF(event){
        let modal = new ExportPDFModal({
            'restaurant': this.restaurant,
        });
    }

    onClickExportExcel(event){
        let modal = new ExportExcelModal({
            'restaurant': this.restaurant,
        });
    }
}

module.exports = BookmarkTab;

